var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceResponsibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 130,
    viewBox: "0 0 284 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2401 30.4355H22.7403C22.9869 26.8446 26.0423 24.0044 29.7855 24.0044C30.6296 24.0044 31.4357 24.1562 32.1862 24.421C32.1798 24.2819 32.1646 24.1449 32.1646 24.0044C32.1646 18.9659 36.3509 14.8816 41.5147 14.8816C42.9017 14.8816 44.2136 15.1842 45.3974 15.7127C47.7017 13.5273 50.842 12.1762 54.3096 12.1762C59.4688 12.1762 63.9033 15.1619 65.9274 19.4533C66.314 19.4083 66.7053 19.3783 67.1045 19.3783C72.5402 19.3783 76.9467 23.6776 76.9467 28.9812C76.9467 29.559 76.8852 30.1219 76.785 30.6715C79.1466 31.3702 80.8836 33.5584 80.8836 36.1352C80.8836 39.2701 78.3147 41.8352 75.1748 41.8352H21.2401C18.1002 41.8352 15.5312 39.2701 15.5312 36.1352C15.5312 33.0006 18.1002 30.4355 21.2401 30.4355Z",
    fill: "#E5E6E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2401 30.4355H22.7403C22.9869 26.8446 26.0423 24.0044 29.7855 24.0044C30.6296 24.0044 31.4357 24.1562 32.1862 24.421C32.1798 24.2819 32.1646 24.1449 32.1646 24.0044C32.1646 18.9659 36.3509 14.8816 41.5147 14.8816C42.9017 14.8816 44.2136 15.1842 45.3974 15.7127C47.7017 13.5273 50.842 12.1762 54.3096 12.1762C59.4688 12.1762 63.9033 15.1619 65.9274 19.4533C66.314 19.4083 66.7053 19.3783 67.1045 19.3783C72.5402 19.3783 76.9467 23.6776 76.9467 28.9812C76.9467 29.559 76.8852 30.1219 76.785 30.6715C79.1466 31.3702 80.8836 33.5584 80.8836 36.1352C80.8836 39.2701 78.3147 41.8352 75.1748 41.8352H21.2401C18.1002 41.8352 15.5312 39.2701 15.5312 36.1352C15.5312 33.0006 18.1002 30.4355 21.2401 30.4355Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.908 10.8892H145.712C145.845 8.96318 147.483 7.43969 149.491 7.43969C149.944 7.43969 150.376 7.52129 150.779 7.66327C150.775 7.58862 150.767 7.51525 150.767 7.43969C150.767 4.73741 153.013 2.54668 155.782 2.54668C156.526 2.54668 157.23 2.70897 157.865 2.99255C159.101 1.82034 160.785 1.09565 162.645 1.09565C165.412 1.09565 167.79 2.69707 168.876 4.99886C169.083 4.97471 169.293 4.95861 169.507 4.95861C172.423 4.95861 174.786 7.26442 174.786 10.109C174.786 10.4192 174.753 10.7208 174.7 11.0156C175.966 11.3905 176.898 12.5641 176.898 13.9464C176.898 15.6276 175.52 17.0034 173.836 17.0034H144.908C143.224 17.0034 141.846 15.6276 141.846 13.9464C141.846 12.265 143.224 10.8892 144.908 10.8892Z",
    fill: "#E5E6E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.908 10.8892H145.712C145.845 8.96318 147.483 7.43969 149.491 7.43969C149.944 7.43969 150.376 7.52129 150.779 7.66327C150.775 7.58862 150.767 7.51525 150.767 7.43969C150.767 4.73741 153.013 2.54668 155.782 2.54668C156.526 2.54668 157.23 2.70897 157.865 2.99255C159.101 1.82034 160.785 1.09565 162.645 1.09565C165.412 1.09565 167.79 2.69707 168.876 4.99886C169.083 4.97471 169.293 4.95861 169.507 4.95861C172.423 4.95861 174.786 7.26442 174.786 10.109C174.786 10.4192 174.753 10.7208 174.7 11.0156C175.966 11.3905 176.898 12.5641 176.898 13.9464C176.898 15.6276 175.52 17.0034 173.836 17.0034H144.908C143.224 17.0034 141.846 15.6276 141.846 13.9464C141.846 12.265 143.224 10.8892 144.908 10.8892Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 100.254C0.998047 101.542 2.04383 102.586 3.33368 102.586C4.62353 102.586 5.66931 101.542 5.66931 100.254C5.66931 98.9659 4.62353 97.9217 3.33368 97.9217C2.04383 97.9217 0.998047 98.9659 0.998047 100.254Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.482 7.48249H249.842V26.1031H264.482V7.48249Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.774 7.86365H247.551V1H266.774V7.86365Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.095 128.967H172.365V55.0869L225.73 18.1682L279.095 55.0869V128.967Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.095 128.967H172.365V55.0869L225.73 18.1682L279.095 55.0869V128.967Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.543 52.884L172.246 57.0063H279.208L279.911 52.884H171.543Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.543 52.884L172.246 57.0063H279.208L279.911 52.884H171.543Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.825 17.7298H182.633L168.457 53.1653H283L268.825 17.7298Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.825 17.7298H182.633L168.457 53.1653H283L268.825 17.7298Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.16 48.9049H281.118",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.842 44.6968H187.381H264.072H279.611",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.529 40.4886H193.467H257.994H277.93",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.213 36.2805H199.55H251.911H276.247",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.893 32.073H205.629H245.825H274.561",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.58 27.8649H211.715H239.746H272.88",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.262 23.6567H217.796H233.662H249.843H264.483H271.195",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M181.941 19.4486H223.876H227.576H249.84H264.48H269.509",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225.728 19.4129L211.623 31.2528V48.9049H225.728H239.834V31.2528L225.728 19.4129Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.728 19.4129L211.623 31.2528V48.9049H225.728H239.834V31.2528L225.728 19.4129Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.729 14.4528L206.084 31.332L211.624 31.2532L225.729 19.4131L239.834 31.2532L245.374 31.332L225.729 14.4528Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.729 14.4528L206.084 31.332L211.624 31.2532L225.729 19.4131L239.834 31.2532L245.374 31.332L225.729 14.4528Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M237.005 124.562H217.246V74.6849H237.005V124.562Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M216.129 73.5675V125.678H218.367V123.445H218.366V75.8013H235.888V123.445H235.875V125.678H238.125V73.5675H216.129Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M216.129 73.5675V125.678H218.367V123.445H218.366V75.8013H235.888V123.445H235.875V125.678H238.125V73.5675H216.129Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M239.707 128.967H214.543V124.562H239.707V128.967Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M233.739 95.3578H220.504V78.7019H233.739V95.3578Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M233.739 120.42H220.504V103.765H233.739V120.42Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.381 100.384C234.381 100.994 233.887 101.487 233.277 101.487C232.667 101.487 232.172 100.994 232.172 100.384C232.172 99.7752 232.667 99.2807 233.277 99.2807C233.887 99.2807 234.381 99.7752 234.381 100.384Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.381 100.384C234.381 100.994 233.887 101.487 233.277 101.487C232.667 101.487 232.172 100.994 232.172 100.384C232.172 99.7752 232.667 99.2807 233.277 99.2807C233.887 99.2807 234.381 99.7752 234.381 100.384Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.854 108.327H186.801V73.5674H202.854V108.327Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M266.819 108.327H250.766V73.5674H266.819V108.327Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.226 45.4648H218.051V30.3131H233.226V45.4648Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M231.987 44.1393H219.467V31.6389H231.987V44.1393Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M231.987 36.984H219.467V38.3981H231.987V36.984Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M224.93 44.1393H226.346V31.6389H224.93V44.1393Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M105.669 65.4995C105.669 74.4148 98.431 81.6418 89.5017 81.6418C80.5725 81.6418 73.334 74.4148 73.334 65.4995C73.334 56.5844 80.5725 49.3574 89.5017 49.3574C98.431 49.3574 105.669 56.5844 105.669 65.4995Z",
    fill: "#231F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M105.669 65.4995C105.669 74.4148 98.431 81.6418 89.5017 81.6418C80.5725 81.6418 73.334 74.4148 73.334 65.4995C73.334 56.5844 80.5725 49.3574 89.5017 49.3574C98.431 49.3574 105.669 56.5844 105.669 65.4995Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M63.0486 78.0946C63.0486 84.3179 57.9956 89.3628 51.7623 89.3628C45.5293 89.3628 40.4766 84.3179 40.4766 78.0946C40.4766 71.8712 45.5293 66.8261 51.7623 66.8261C57.9956 66.8261 63.0486 71.8712 63.0486 78.0946Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M63.0486 78.0946C63.0486 84.3179 57.9956 89.3628 51.7623 89.3628C45.5293 89.3628 40.4766 84.3179 40.4766 78.0946C40.4766 71.8712 45.5293 66.8261 51.7623 66.8261C57.9956 66.8261 63.0486 71.8712 63.0486 78.0946Z",
    fill: "#231F20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.709 60.1784L66.8887 90.7657",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8894 96.5021L51.7617 77.0771",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8887 34.6517V67.1067V67.108V87.0904V90.7656V91.6669V96.5015V99.3187V100.191V102.939V103.137V103.419V104.645V106.448V107.238V107.294V108.675V112.492V113.389V113.715V113.986V114.612V114.883V115.209V116.107V120.081V120.927V121.147V124.436V125.176V127.185V128.967",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_471_9459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 43,
    width: 138,
    height: 75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3632 117.089H83.2194C78.0898 117.089 73.9021 112.901 73.9021 107.667V91.9635C73.9021 89.0322 75.1583 86.4152 77.4615 84.6354L123.106 48.7274C127.398 45.3775 132.632 43.5977 138.076 43.5977H200.888C206.123 43.5977 210.31 47.7852 210.31 52.915V93.2197C210.31 105.573 200.888 115.728 188.849 116.984",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3632 117.089H83.2194C78.0898 117.089 73.9021 112.901 73.9021 107.667V91.9635C73.9021 89.0322 75.1583 86.4152 77.4615 84.6354L123.106 48.7274C127.398 45.3775 132.632 43.5977 138.076 43.5977H200.888C206.123 43.5977 210.31 47.7852 210.31 52.915V93.2197C210.31 105.573 200.888 115.728 188.849 116.984",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_471_9459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.546 403.273H-20.0061V16.3907H517.546V403.273Z",
    fill: "#F84800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6433 51.8221V42.6861L62.0712 40.9716V50.1076L55.213 47.5358L48.0662 57.7935L66.3546 64.6516L73.5014 54.3939L66.6433 51.8221Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3591 56.9659L84.9312 58.6806L79.828 66.0833L75.2557 64.3688L80.3591 56.9659Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0888 35.5289V26.3929L87.5167 24.6784V33.8144L80.6583 31.2426L73.5115 41.5001L91.8001 48.3584L98.9467 38.1007L92.0888 35.5289Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.802 40.6729L110.375 42.3874L105.271 49.79L100.699 48.0755L105.802 40.6729Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7761 81.8314V72.6954L73.204 70.9807V80.1167L66.3458 77.5449L59.199 87.8026L77.4876 94.6609L84.6342 84.4032L77.7761 81.8314Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9189 111.842V102.706L84.3468 100.991V110.127L77.4884 107.555L70.3416 117.813L88.6301 124.671L95.7768 114.413L88.9189 111.842Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22 65.5387V56.4027L98.6475 54.6882V63.8242L91.7894 61.2523L84.6423 71.51L102.931 78.3682L110.078 68.1107L103.22 65.5387Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.362 95.5484V86.4124L109.79 84.698V93.8339L102.932 91.2621L95.7849 101.52L114.073 108.378L121.22 98.1204L114.362 95.5484Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5036 86.9764L96.0758 88.6909L90.9724 96.0935L86.4001 94.379L91.5036 86.9764Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.665 49.2462V40.1102L124.093 38.3955V47.5315L117.235 44.9597L110.088 55.2173L128.376 62.0757L135.523 51.818L128.665 49.2462Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.078 100.693L132.65 102.407L127.547 109.81L122.974 108.096L128.078 100.693Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.806 79.2564V70.1205L135.233 68.4058V77.5417L128.375 74.9699L121.228 85.2276L139.517 92.0859L146.664 81.8283L139.806 79.2564Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.947 70.6834L121.519 72.3979L116.416 79.8005L111.844 78.086L116.947 70.6834Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.108 32.9541V23.8181L149.536 22.1036V31.2396L142.678 28.6677L135.531 38.9254L153.82 45.7836L160.966 35.5261L154.108 32.9541Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.521 84.4005L158.093 86.1149L152.99 93.5176L148.418 91.8031L153.521 84.4005Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.249 62.9632V53.8272L160.677 52.1127V61.2487L153.818 58.6769L146.672 68.9346L164.96 75.7927L172.107 65.5352L165.249 62.9632Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39 54.3914L146.963 56.1059L141.859 63.5085L137.287 61.7941L142.39 54.3914Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.959 68.1071L183.531 69.8217L178.428 77.2244L173.855 75.5099L178.959 68.1071Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.684 46.6701V37.5342L186.112 35.8197V44.9556L179.254 42.3838L172.107 52.6413L190.396 59.4996L197.542 49.242L190.684 46.6701Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.826 38.0973L172.398 39.8118L167.295 47.2146L162.722 45.4999L167.826 38.0973Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.402 51.8141L208.974 53.5286L203.871 60.9313L199.299 59.2168L204.402 51.8141Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.126 30.3775V21.2417L211.554 19.5271V28.663L204.696 26.0912L197.549 36.3489L215.837 43.207L222.984 32.9495L216.126 30.3775Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.493 125.557V116.421L120.921 114.706V123.842L114.063 121.271L106.916 131.528L125.204 138.386L132.351 128.129L125.493 125.557Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.934 109.264V100.129L146.362 98.414V107.55L139.504 104.978L132.357 115.236L150.646 122.094L157.792 111.836L150.934 109.264Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.378 92.9719V83.8359L171.806 82.1214V91.2574L164.947 88.6856L157.801 98.9432L176.089 105.801L183.236 95.5437L176.378 92.9719Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 122.982V113.846L182.95 112.131V121.267L176.092 118.695L168.945 128.953L187.233 135.811L194.38 125.553L187.522 122.982Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.66 114.409L169.232 116.124L164.129 123.527L159.556 121.812L164.66 114.409Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.815 76.6787V67.5429L197.243 65.8282V74.9642L190.385 72.3923L183.238 82.65L201.526 89.5082L208.673 79.2507L201.815 76.6787Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 106.689V97.5528L208.384 95.8381V104.974L201.526 102.402L194.379 112.66L212.667 119.518L219.814 109.261L212.956 106.689Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.097 98.1159L194.669 99.8304L189.566 107.233L184.994 105.519L190.097 98.1159Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.259 60.3861V51.2501L222.687 49.5356V58.6716L215.828 56.0997L208.681 66.3574L226.97 73.2156L234.117 62.9579L227.259 60.3861Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.539 81.8233L220.111 83.5378L215.008 90.9404L210.435 89.2259L215.539 81.8233Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9282 49.5449V58.6803L91.7864 61.252V48.3593L73.4978 41.5008V54.3938L80.3561 56.9658V47.8304L84.9282 49.5449Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.372 33.2522V42.3876L117.23 44.9595L117.23 32.0667L98.9412 25.2083V38.1013L105.799 40.6731V31.5377L110.372 33.2522Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6292 95.8476V104.983L77.4874 107.555V94.662L59.199 87.8037V100.697L66.0571 103.268V94.1331L70.6292 95.8476Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.206 109.564V118.7L114.064 121.271L114.064 108.379L95.7751 101.52V114.413L102.633 116.985V107.85L107.206 109.564Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0728 79.5551V88.6906L102.931 91.2622L102.931 78.3696L84.6423 71.5112V84.4042L91.5007 86.9761V77.8406L96.0728 79.5551Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.649 93.2716V102.407L139.507 104.979V92.0862L121.219 85.2277V98.1207L128.077 100.693V91.5571L132.649 93.2716Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.518 63.2625V72.3979L128.376 74.9697V62.0769L110.088 55.2186V68.1116L116.946 70.6834V61.548L121.518 63.2625Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.094 76.9796V86.1151L164.952 88.6869L164.952 75.7941L146.664 68.9357V81.8287L153.522 84.4006V75.2651L158.094 76.9796Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.961 46.9699V56.1053L153.82 58.6771V45.7843L135.531 38.926V51.819L142.389 54.3908V45.2554L146.961 46.9699Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.532 60.6855V69.8209L190.39 72.3926V59.4999L172.101 52.6414V65.5344L178.96 68.1064V58.9708L183.532 60.6855Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.971 44.3932V53.5286L215.829 56.1005V43.2076L197.541 36.3493V49.2423L204.399 51.8141V42.6787L208.971 44.3932Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.787 123.281V132.416L150.646 134.988V122.095L132.357 115.237V128.13L139.216 130.702V121.566L143.787 123.281Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.231 106.988V116.124L176.089 118.696V105.803L157.801 98.9444V111.837L164.659 114.409V105.274L169.231 106.988Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.801 120.704V129.84L212.659 132.411V119.519L194.371 112.66V125.553L201.229 128.125V118.99L205.801 120.704Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.668 90.6944V99.8298L201.527 102.402V89.5088L183.238 82.6505V95.5435L190.096 98.1153V88.9799L194.668 90.6944Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.112 74.4025V83.538L226.97 86.1096L226.97 73.217L208.681 66.3587V79.2515L215.54 81.8235V72.6881L220.112 74.4025Z",
    fill: "#FF9C5E"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.41 56.9757H129.202C128.26 56.9757 127.346 57.2916 126.605 57.8729L114.041 67.7306C110.895 70.1984 112.64 75.2493 116.638 75.2493H148.41V56.9757Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9021 103.159V107.732C73.9021 112.904 78.0942 117.096 83.2659 117.096H186.417C196.055 117.096 204.34 111.377 208.119 103.159H73.9021Z",
    fill: "#F14E1C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9021 103.159V107.732C73.9021 112.904 78.0942 117.096 83.2659 117.096H186.417C196.055 117.096 204.34 111.377 208.119 103.159H73.9021Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M173.164 120.573C168.355 120.573 164.457 116.675 164.457 111.865C164.457 107.056 168.355 103.158 173.164 103.158C177.973 103.158 181.872 107.056 181.872 111.865C181.872 116.675 177.973 120.573 173.164 120.573ZM173.164 95.2815C164.005 95.2815 156.58 102.707 156.58 111.865C156.58 121.025 164.005 128.449 173.164 128.449C182.323 128.449 189.749 121.025 189.749 111.865C189.749 102.707 182.323 95.2815 173.164 95.2815Z",
    fill: "#F84800"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.09 120.573C106.281 120.573 102.383 116.675 102.383 111.865C102.383 107.056 106.281 103.158 111.09 103.158C115.899 103.158 119.797 107.056 119.797 111.865C119.797 116.675 115.899 120.573 111.09 120.573ZM111.09 95.2815C101.931 95.2815 94.5057 102.707 94.5057 111.865C94.5057 121.025 101.931 128.449 111.09 128.449C120.249 128.449 127.674 121.025 127.674 111.865C127.674 102.707 120.249 95.2815 111.09 95.2815Z",
    fill: "#F84800"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M157.442 117.088H126.664",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3632 117.089H83.2194C78.0898 117.089 73.9021 112.901 73.9021 107.667V91.9635C73.9021 89.0322 75.1583 86.4152 77.4615 84.6354L123.106 48.7274C127.398 45.3775 132.632 43.5977 138.076 43.5977H200.888C206.123 43.5977 210.31 47.7852 210.31 52.915V93.2197C210.31 105.573 200.888 115.728 188.849 116.984",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M180.057 117.088H166.238",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M117.975 117.088H104.156",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M148.363 56.9627H129.156C128.214 56.9627 127.299 57.2786 126.558 57.8599L113.994 67.7178C110.848 70.1855 112.593 75.2365 116.591 75.2365H148.363V56.9627Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.115 120.56C168.307 120.56 164.408 116.662 164.408 111.852C164.408 107.043 168.307 103.145 173.115 103.145C177.924 103.145 181.823 107.043 181.823 111.852C181.823 116.662 177.924 120.56 173.115 120.56ZM173.115 95.2686C163.956 95.2686 156.531 102.694 156.531 111.852C156.531 121.012 163.956 128.437 173.115 128.437C182.274 128.437 189.7 121.012 189.7 111.852C189.7 102.694 182.274 95.2686 173.115 95.2686Z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.115 120.56C168.307 120.56 164.408 116.662 164.408 111.852C164.408 107.043 168.307 103.145 173.115 103.145C177.924 103.145 181.823 107.043 181.823 111.852C181.823 116.662 177.924 120.56 173.115 120.56ZM173.115 95.2686C163.956 95.2686 156.531 102.694 156.531 111.852C156.531 121.012 163.956 128.437 173.115 128.437C182.274 128.437 189.7 121.012 189.7 111.852C189.7 102.694 182.274 95.2686 173.115 95.2686Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.043 120.56C106.234 120.56 102.336 116.662 102.336 111.852C102.336 107.043 106.234 103.145 111.043 103.145C115.852 103.145 119.75 107.043 119.75 111.852C119.75 116.662 115.852 120.56 111.043 120.56ZM111.043 95.2687C101.884 95.2687 94.4589 102.694 94.4589 111.852C94.4589 121.012 101.884 128.437 111.043 128.437C120.202 128.437 127.628 121.012 127.628 111.852C127.628 102.694 120.202 95.2687 111.043 95.2687Z",
    fill: "#231F20"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M111.043 120.56C106.234 120.56 102.336 116.662 102.336 111.852C102.336 107.043 106.234 103.145 111.043 103.145C115.852 103.145 119.75 107.043 119.75 111.852C119.75 116.662 115.852 120.56 111.043 120.56ZM111.043 95.2687C101.884 95.2687 94.4589 102.694 94.4589 111.852C94.4589 121.012 101.884 128.437 111.043 128.437C120.202 128.437 127.628 121.012 127.628 111.852C127.628 102.694 120.202 95.2687 111.043 95.2687Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.045 120.56C106.236 120.56 102.338 116.662 102.338 111.852C102.338 107.044 106.236 103.145 111.045 103.145C115.854 103.145 119.752 107.044 119.752 111.852C119.752 116.662 115.854 120.56 111.045 120.56Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M111.045 120.56C106.236 120.56 102.338 116.662 102.338 111.852C102.338 107.044 106.236 103.145 111.045 103.145C115.854 103.145 119.752 107.044 119.752 111.852C119.752 116.662 115.854 120.56 111.045 120.56Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M173.162 120.56C168.353 120.56 164.455 116.662 164.455 111.852C164.455 107.044 168.353 103.145 173.162 103.145C177.971 103.145 181.869 107.044 181.869 111.852C181.869 116.662 177.971 120.56 173.162 120.56Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.162 120.56C168.353 120.56 164.455 116.662 164.455 111.852C164.455 107.044 168.353 103.145 173.162 103.145C177.971 103.145 181.869 107.044 181.869 111.852C181.869 116.662 177.971 120.56 173.162 120.56Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M87.418 45.8626C87.418 57.6034 77.8852 67.121 66.126 67.121C54.3668 67.121 44.834 57.6034 44.834 45.8626C44.834 34.1217 54.3668 24.6041 66.126 24.6041C77.8852 24.6041 87.418 34.1217 87.418 45.8626Z",
    fill: "#231F20"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M87.418 45.8626C87.418 57.6034 77.8852 67.121 66.126 67.121C54.3668 67.121 44.834 57.6034 44.834 45.8626C44.834 34.1217 54.3668 24.6041 66.126 24.6041C77.8852 24.6041 87.418 34.1217 87.418 45.8626Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceResponsibility);
export default __webpack_public_path__ + "static/media/maintenance-responsibility.6205e411.svg";
export { ForwardRef as ReactComponent };